<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    class="burger-icon"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M3 12h18M3 6h18M3 18h18" />
  </svg>
</template>

<style  lang="scss">
.burger-icon {
  display: block;
}
</style>
